import { render, staticRenderFns } from "./Additem.vue?vue&type=template&id=419cb0d6&"
import script from "./Additem.vue?vue&type=script&lang=js&"
export * from "./Additem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports